import { getRolesAndPermissions } from '@/libs/api/api';
import { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'
import constants from '@/libs/constant/constants'
export default {
    computed: {
        ...mapGetters({
            organisationRoles: 'getOrganisationRoles',
            teamRoles: 'getTeamRoles',
            isUpdateOrganisationRoles: 'getUpdateOrganisationRoles',
            isUpdateTeamRoles: 'getUpdateTeamRoles'
        })
    },
    watch: {
        isUpdateOrganisationRoles (newValue) {
            if (newValue) this.updateRolesAndPermissions()
        },
        isUpdateTeamRoles (newValue) {
            if (newValue) this.updateRolesAndPermissions(true)
        }
    },
    methods: {
        /**
         * set organisation roles & permissions
         */
        async setOrganisationRoleAndPermissions (isRefresh) {
            try {
                if (isRefresh || isEmpty(this.organisationRoles)) {
                    // body
                    let body = {
                        entity_type: constants.ORGANISATIONS.ORGANISATION,
                        entity_id: this.$route.params.id
                    }
                    // api call
                    let response = await getRolesAndPermissions(body)
                    // setting roles and permissions of ORG to store
                    this.$store.dispatch('setOrganisationRoles', response)
                }
            } catch (error) {
                console.error(error)
            }
        },

        /**
         * set team roles and permissions
         */
        async setTeamRolesAndPermission (isRefresh) {
            try {
                if (isRefresh || isEmpty(this.teamRoles) && this.$route.params.tid) {
                    // body for api
                    let body = {
                        entity_type: constants.ORGANISATIONS.TEAM,
                        entity_id: this.$route.params.tid
                    }
                    // api call
                    let response = await getRolesAndPermissions(body)
                    // setting team roles and permission to store
                    this.$store.dispatch('setTeamRoles', response)
                }
            } catch (error) {
                console.error(error)
            }
        },
        /**
         * 
         * @param {*} isTeam 
         */
        updateRolesAndPermissions (isTeam) {
            // updation for team
            if (isTeam) {
                // update roles and permission of team
                this.setTeamRolesAndPermission(true)
                // to update store
                this.$store.dispatch('setUpdateTeamRoles', false)
            }
            // for organisation
            else {
                // update roles and permission of team
                this.setOrganisationRoleAndPermissions(true)
                // to update store
                this.$store.dispatch('setUpdateOrganisationRoles', false)
            }
        }
    }
}